/**
 * The app bundle an HTML shell loads (`/assets/app-<hash>.js`), or null when it names none.
 *
 * A deploy replaces the hashed bundle, so a tab whose bundle differs from the one the server now serves is running
 * code from before that deploy, against an API that may have changed shape since.
 */
export function shellBundle(html: string): string | null {
  return html.match(/<script\b[^>]*\bsrc="(\/assets\/app[^"]*\.js)"/)?.[1] ?? null;
}

/** Whether the shell the server serves now loads a different bundle from the one this tab is running. */
export const isStaleBundle = (running: string | null, servedHtml: string) => {
  const served = shellBundle(servedHtml);
  return running !== null && served !== null && served !== running;
};
